import React from 'react';
import { YStack } from 'tamagui';
import { BodyText, SectionTitle } from '@/components/ui/Typography';

export default function ExploreScreen() {
  return (
    <YStack flex={1} backgroundColor="$bg" padding="$4" justifyContent="center" alignItems="center">
      <SectionTitle color="$color">
        Explore Screen
      </SectionTitle>
      <BodyText color="$gray9" textAlign="center" marginTop="$4">
                Explore Description

      </BodyText>
    </YStack>
  );
}